<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>
<script>
export default {
    provide() {
        return {
            reload: this.reload
        }
    },
    data() {
        return {
            isRouterAlive: true
        }
    },
    methods: {
        reload() {
            this.isRouterAlive = false
            this.$nextTick(() => {
                this.isRouterAlive = true
            })
        }
    }
}
</script>

<style>
html,
body {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-color: #f4f4f4;
}

#app {
    margin: 0 auto;
    width: 100%;
    height: 100%;
    background: #ececec;
    display: flex;
    flex-direction: column;
}

@media screen and (min-width: 581px) {
    #app {
        max-width: 580px;
    }
}

audio,
canvas,
embed,
iframe,
img,
object,
svg,
video {
    max-width: 100%;
    font-style: italic;
    vertical-align: middle;
}
</style>